export default function fetchData({
  endpoint,
  method = "GET",
  data,
  headers = {},
}) {
  return new Promise((resolve, reject) => {
    fetch(endpoint, {
      method,
      headers,
      body: data,
    })
      .then(async (r) => {
        const response = await r.json();
        if (!r.ok) {
          reject(response);
        }
        return response;
      })
      .then((parsedData) => {
        resolve(parsedData);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
}

export function fetchMetrics({ endpoint, params }) {
  return new Promise((resolve, reject) => {
    let url = `https://metrics-ss.temptunnel.com/api/${endpoint}`;
    if (params) {
      url += params;
    }
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-ss-token": process.env.METRICS_SS_TOKEN,
      },
    })
      .then(async (r) => {
        if (!r.ok) {
          reject("Error getting metrics data");
        }
        const data = await r.json();
        resolve(data);
      })
      .catch((error) => {
        resolve("ERror getting metrics data");
      });
  });
}
